export default "__VITE_ASSET__6EgHA89y__"